export const VehicleActionTypes = {
  SET_VEHICLES: 'SET_VEHICLES',
  SET_VEHICLES_MAP_DATA: 'SET_VEHICLES_MAP_DATA',
  SET_VEHICLE: 'SET_VEHICLE'
};
